export default "__VITE_ASSET__b6_WbqeF__"